import React from 'react';
import './index.css'

const Footer = () => (
  <div className="footer">
    <div className="footer_title">REFERENCES:</div>
    <div className="aligned">
      - <div className="footer_reference" onClick={()=>window.location = "https://science.sciencemag.org/content/356/6343/1140"}>- Juan, Yuan, Yu-Huai. (2017). Satellite-based entanglement distribution over 1200 kilometers Science Vol. 356, Issue 6343, pp. 1140-1144 DOI: 10.1126/science.aan3211 </div>
      - <div className="footer_reference" onClick={()=>window.location = "https://solarsystem.nasa.gov/planets/mars/overview"}> - Mars overview</div>
      - <div className="footer_reference" onClick={()=>window.location = "https://mars.nasa.gov"}> - NASA's Mars exploration program</div>
      - <div className="footer_reference" onClick={()=>window.location = "https://mars.nasa.gov/insight/mission/communications/"}> - Mars insight Missions</div>
      - <div className="footer_reference" onClick={()=>window.location = "https://deepspace.jpl.nasa.gov"}> - Deep Space Networks (DSN)</div>
      - <div className="footer_reference" onClick={()=>window.location = "https://www.nasa.gov/mission_pages/tdm/dsoc/index.html"}> - Deep Space Optical Communication</div>
      - <div className="footer_reference" onClick={()=>window.location = "https://www.youtube.com/watch?v=-WSWz1H3mJg"}> - Quantum Entanglement Explained for Beginners | Physics Concepts Made Easy</div>
    
    </div> 
    <div className="bar"></div> 
    <div className="footer_title">MADE BY:</div>
    <div className="footer_section">
      <div className="footer_subtitle">Saúl Contreras</div>
      <div className="footer_subtitle">Katherin Contreras</div>
    </div>
    
  </div>
)

export default Footer